import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import GlyphIcon, { HAMBURGER } from '../../ui/GlyphIcon';

import './SidebarToggle.module.scss';

/**
 * Displays a hamburger icon which, when pressed, toggles the sidebar open and closed.
 */
const SidebarToggle = ({ appearance, toggle }) => (
  <View styleName="sidebar-toggle" testID="sidebar-toggle">
    <GlyphIcon
      content={HAMBURGER}
      onPress={toggle}
      styleName={`toggle-${appearance}`}
    />
  </View>
);

SidebarToggle.propTypes = {
  /**
   * Determines the appearance of the toggle. `dark` renders a component with dark background and
   * light foreground, whereas `light` does the opposite.
   */
  appearance: PropTypes.oneOf([
    'dark',
    'light',
    'transparent',
  ]),
  /**
   * Function provided by redux to open and close the sidebar
   */
  toggle: PropTypes.func,
};

SidebarToggle.defaultProps = {
  appearance: 'light',
  toggle: () => {},
};

export default SidebarToggle;
